import { ShoppingCartManager } from 'webshop/js/shopping-cart-manager';


export const sendEnhancedAnalytics = (stepNb, stepText=null) => {
    const productData = ShoppingCartManager.getAll().rows.map(product => {
        if (product.product_type == 'work') {
            return {
              'name': product.work_type_text,
              'id': product.id,
              'price': product.unit_price,
              'brand': 'RENGAS TURKU',
              'category': 'Työ',
              'quantity': parseInt(product.count)
            }
        }
        const tireTypes = {
            'summer': 'Kesärenkaat',
            'friction': 'Kitkarenkaat',
            'studded': 'Nastarenkaat',
            'truck': 'KA',
            'work': 'TK',
            'race': 'Kilparenkaat',
            'other': 'Muut renkaat',
        }

        let category = '';
        if (product.product_type == 'tire') {
          category = `${tireTypes[product.tire_type]}${product.used ? ' käytetyt' : ''}`;
        } else if (product.product_type == 'accessory') {
          category = 'Tarvikkeet';
        } else {
          category = `${product.wheel_type == 'alloy' ? 'Alumiinivanteet' : 'Peltivanteet'}${product.used ? ' käytetyt' : ''}`;
        }
        return {
          'name': product.brand + ' ' + product.model,
          'id': product.id,
          'price': product.unit_price,
          'brand': product.brand,
          'category': category,
          'quantity': parseInt(product.count)
        }
    });
    const option = stepText ? {'option': stepText} : {};
    dataLayer.push({
      'event': 'checkout',
      'ecommerce': {
        'currencyCode': 'EUR',
        'checkout': {
          'actionField': {'step': stepNb, ...option},
          'products': productData
        }
      },
      'eventCallback': function() {}
    });
};

export const onCheckoutOption = (step, checkoutOption) => {
  dataLayer.push({
    'event': 'checkoutOption',
    'ecommerce': {
      'currencyCode': 'EUR',
      'checkout_option': {
        'actionField': {'step': step, 'option': checkoutOption}
      }
    }
  });
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/analytics.js
 **/